import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import {
  IBookFlightRequest,
  IBookFlightResponseData,
} from '../../../types/flight';
import { RootState } from '../..';
import { getAccountBalanceAsync } from '../account/getAccountBalanceSlice';

interface IBookFlightResponse {
  status?: boolean;
  message?: string;
  data?: IBookFlightResponseData;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IBookFlightResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const bookFlightAsync = createAsyncThunk(
  'flights/bookFlight',
  async (
    values: IBookFlightRequest,
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.post('flights/book-flight', values, config);

      dispatch(getAccountBalanceAsync());

      return data;
    } catch (err) {
      const error = err as AxiosError<IBookFlightResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const flightBookSlice = createSlice({
  name: 'flights/bookFlight',
  initialState,
  reducers: {
    resetBookFlight: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(bookFlightAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(bookFlightAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IBookFlightResponse;
      })
      .addCase(bookFlightAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IBookFlightResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetBookFlight } = flightBookSlice.actions;

export default flightBookSlice.reducer;
